/**
 * Utility functions for managing returnPath in localStorage.
 * These write directly to localStorage to ensure persistence before browser navigation.
 */

const STORAGE_KEY = 'preferences';

export const setReturnPathInStorage = (returnPath: string): void => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		const parsed = stored ? JSON.parse(stored) : { state: {}, version: 0 };
		parsed.state = parsed.state || {};
		parsed.state.returnPath = returnPath;
		localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
	} catch {
		// Ignore errors
	}
};

export const getReturnPathFromStorage = (): string | undefined => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored) {
			const parsed = JSON.parse(stored);
			return parsed.state?.returnPath;
		}
	} catch {
		// Ignore errors
	}
	return undefined;
};

export const clearReturnPathFromStorage = (): void => {
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored) {
			const parsed = JSON.parse(stored);
			if (parsed.state) {
				parsed.state.returnPath = undefined;
				localStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
			}
		}
	} catch {
		// Ignore errors
	}
};

